/**
 * One training video: the MP4 (captions are burned in; the VTT track is there for screen readers / search and is
 * off by default so they are not shown twice). Portrait (phone) videos get a narrower frame.
 */
import { Skeleton } from '@/components/ui/skeleton';
import { useTrainingVideo } from '@/lib/training';
import { cn } from '@/lib/utils';
import type { TrainingVideo } from '@shared/training.ts';

export function TrainingPlayer({ video, autoPlay, className }: { video: TrainingVideo; autoPlay?: boolean; className?: string }) {
  const s = useTrainingVideo(video);
  const frame = cn('mx-auto w-full overflow-hidden rounded-2xl border border-border bg-ink/90 shadow-[var(--shadow-card)]',
    video.portrait ? 'aspect-[9/16] max-w-[22rem]' : 'aspect-video', className);
  if (s.status === 'loading') return <Skeleton className={frame} />;
  if (s.status === 'missing') {
    return (
      <div className={cn(frame, 'flex items-center justify-center bg-surface-2 p-6 text-center text-ink-2')}>
        הסרטון עוד לא הועלה. בינתיים אפשר לקרוא את המדריך.
      </div>
    );
  }
  return (
    <div className={frame}>
      <video key={s.urls.mp4} controls playsInline preload="metadata" autoPlay={autoPlay} poster={s.urls.jpg ?? undefined}
        className="size-full bg-black object-contain" aria-label={video.title}>
        <source src={s.urls.mp4} type="video/mp4" />
        {s.urls.vtt ? <track kind="captions" srcLang="he" label="עברית" src={s.urls.vtt} /> : null}
      </video>
    </div>
  );
}
